import { render } from "./MainBottomBar.vue?vue&type=template&id=a8067472&scoped=true"
const script = {}

import "./MainBottomBar.vue?vue&type=style&index=0&id=a8067472&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8067472"]])

export default __exports__